import * as ActionCable from "@rails/actioncable"

ActionCable.logger.enabled = true
